  <br /><br />
  <h4 style="font-weight:bold; text-decoration:underline; text-align:center">Selected: Agree</h4><br/>
  <div class="container" style="border:1px solid #bebaba">

    <div class="container-fluid">
      <div class="row mt-5" style="margin-left: 0px; margin-right: 0px">
        <div class="col-md-12 text-center" style="background-color: lightgrey; font-size: 1.4em; font-weight: bold">
          Claimant Information
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <form [formGroup]="claimantsInformation" (ngSubmit)="onSubmit()">
            <div class="row mt-3">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="titleBold" for="noticeId">Notice ID Number:</label>
                  <input type="text" class="form-control" id="noticeId" formControlName="noticeId" readonly />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="titleBold" for="uniqueId">Unique ID Number:</label>
                  <input type="text" class="form-control" id="uniqueId" formControlName="uniqueId" readonly />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <input type="text" class="form-control" id="filingType" formControlName="filingType" hidden />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label class="titleBold" for="attention">Contact Name:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                  <input type="text" class="form-control" id="attention" formControlName="attention" placeholder=""
                         autocomplete="off" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.attention.errors }" />
                  <div *ngIf="submitted && f.attention.errors" class="invalid-feedback">
                    <div *ngIf="f.attention.errors.required">This field is required</div>
                    <div *ngIf="f.attention.errors.minlength">This field must be at least 2 characters</div>
                    <div *ngIf="f.attention.errors.maxlength">This field must not be at greater 50 characters</div>
                    <div *ngIf="f.attention.errors.pattern">Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label class="titleBold" for="name1">Company Name:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                  <input type="text" class="form-control" id="name1" formControlName="name1" placeholder=""
                         autocomplete="off" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.name1.errors }" />
                  <div *ngIf="submitted && f.name1.errors" class="invalid-feedback">
                    <div *ngIf="f.name1.errors.required">This field is required</div>
                    <div *ngIf="f.name1.errors.minlength">This field must be at least 2 characters</div>
                    <div *ngIf="f.name1.errors.maxlength">This field must not be at greater 50 characters</div>
                    <div *ngIf="f.name1.errors.pattern">Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label class="titleBold" for="street1">Street Address 1:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                  <input type="text" class="form-control" id="street1" formControlName="street1" autocomplete="no"
                         trim="blur" [ngClass]="{ 'is-invalid': submitted && f.street1.errors }" />
                  <div *ngIf="submitted && f.street1.errors" class="invalid-feedback">
                    <div *ngIf="f.street1.errors.required">This field is required</div>
                    <div *ngIf="f.street1.errors.maxlength">This field must not be at greater 50 characters</div>
                    <div *ngIf="f.street1.errors.minlength">This field must be at least 2 characters</div>
                    <div *ngIf="f.street1.errors.pattern">
                      Only use letters, numbers, periods, spaces, hyphens,
                      brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label class="titleBold" for="street2">Street Address 2:</label>
                  <input type="text" class="form-control" id="street2" formControlName="street2" autocomplete="no"
                         trim="blur" [ngClass]="{ 'is-invalid': submitted && f.street2.errors }" />
                  <div *ngIf="submitted && f.street2.errors" class="invalid-feedback">
                    <div *ngIf="f.street2.errors.maxlength">This field must not be at greater 50 characters</div>
                    <div *ngIf="f.street2.errors.minlength">This field must be at least 2 characters</div>
                    <div *ngIf="f.street2.errors.pattern">
                      Only use letters, numbers, periods, spaces, hyphens,
                      brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="country"><b>Country</b>:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                  <select class="form-control" formControlName="country" (change)="getCountryValue($event)" [ngClass]="{ 'is-invalid': submitted && f.country.errors }">
                    <option value="">Please Select A Country</option>
                    <option *ngFor="let allcountry of allCountries">
                      {{allcountry.Name}}
                    </option>
                  </select>
                  <div *ngIf="submitted && f.country.errors" class="invalid-feedback">
                    <div *ngIf="f.country.errors.required">This field is required</div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="city"><b>City</b>:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                  <input type="text" class="form-control" formControlName="city" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.city.errors }" />
                  <div *ngIf="(changed || submitted) && f.city.errors" class="invalid-feedback">
                    <div *ngIf="f.city.errors.required">This field is required</div>
                    <div *ngIf="f.city.errors.minlength">This field must be at least 2 characters</div>
                    <div *ngIf="f.city.errors.maxlength">This field must not be at greater 40 characters</div>
                    <div *ngIf="f.city.errors.pattern">
                      Only use letters, numbers, periods, spaces, hyphens,
                      brackets,
                      ampersands, apostophes, parentheses slash(/), pound sign(#)
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="showDivProvince">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="province"><b>Province:</b><span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                    <input type="text" class="form-control" formControlName="province" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.province.errors }" />
                    <div *ngIf="(changed || submitted) && f.province.errors" class="invalid-feedback">
                      <div *ngIf="f.province.errors.required">This field is required</div>
                      <div *ngIf="f.province.errors.minlength">This field must be at least 2 characters</div>
                      <div *ngIf="f.province.errors.maxlength">This field must not be at greater 50 characters</div>
                      <div *ngIf="f.province.errors.pattern">
                        Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="postalCode"><b>Postal Code:</b></label>
                    <input type="text" class="form-control" formControlName="postalCode" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.postalCode.errors }" />
                    <div *ngIf="f.postalCode.errors" class="invalid-feedback">
                      <div *ngIf="f.postalCode.errors.maxlength">This field must not be greater than 10 characters</div>
                      <div *ngIf="f.postalCode.errors.pattern">
                        Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row rowformat" *ngIf="showDivCityStateZip">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="state"><b>State</b>:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                  <select class="form-control" formControlName="state" [ngClass]="{ 'is-invalid': submitted && f.state.errors }">
                    <option value="">Please Select A State</option>
                    <option *ngFor="let allstate of allStates">
                      {{allstate.Name}}
                    </option>
                  </select>
                  <div *ngIf="(changed || submitted) && f.state.errors" class="invalid-feedback">
                    <div *ngIf="f.state.errors.required">This field is required</div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="zip"><b>Zip Code</b>:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                  <input type="text" class="form-control" formControlName="zip" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.zip.errors }" />
                  <div *ngIf="(changed || submitted) && f.zip.errors" class="invalid-feedback">
                    <div *ngIf="f.zip.errors.required">This field is required</div>
                    <div *ngIf="f.zip.errors.pattern">
                      US zip Code with format 99999 or 99999-9999 alone are
                      accepted
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label class="titleBold" for="emailAddress">Email Address:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                  <input type="text" class="form-control" id="emailAddress" formControlName="emailAddress" autocomplete="no"
                         trim="blur" [ngClass]="{ 'is-invalid': submitted && f.emailAddress.errors }" />
                  <div *ngIf="submitted && f.emailAddress.errors" class="invalid-feedback">
                    <div *ngIf="f.emailAddress.errors.required">This field is required</div>
                    <div *ngIf="f.emailAddress.errors.maxlength">This field must not be at greater 255 characters</div>
                    <div *ngIf="f.emailAddress.errors.pattern">This is not a valid email address</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="titleBold" for="primaryPhoneType">Primary Phone Type:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                  <select class="form-control" formControlName="primaryPhoneType" [ngClass]="{ 'is-invalid': submitted && f.primaryPhoneType.errors }">
                    <option value="">Please Select Phone Type</option>
                    <option value="Cell">Cell</option>
                    <option value="Landline">Landline</option>
                  </select>
                  <div *ngIf="submitted && f.primaryPhoneType.errors" class="invalid-feedback">
                    <div *ngIf="f.primaryPhoneType.errors.required">This field is required</div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="titleBold" for="primaryPhone">Primary Phone Number:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                  <input type="text" mask="000 000-0000" class="form-control" id="primaryPhone" formControlName="primaryPhone" placeholder=""
                         autocomplete="off" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.primaryPhone.errors }" />
                  <div *ngIf="submitted && f.primaryPhone.errors" class="invalid-feedback">
                    <div *ngIf="f.primaryPhone.errors.required">This field is required</div>
                    <div *ngIf="f.primaryPhone.errors.minlength">This field must be at least 10 digits</div>
                    <div *ngIf="f.primaryPhone.errors.maxlength">This field must not be at greater 10 digits</div>
                    <div *ngIf="f.primaryPhone.errors.pattern">Only use numbers</div>
                  </div>
                </div>
              </div>
            </div>


            <div class="row mt-4" style="margin-left: 0px; margin-right: 0px">
              <div class="col-md-12 text-center" style="background-color: lightgrey; font-size: 1.4em; font-weight: bold">
                Review Your Purchase Information
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-12">
                The total award amount you receive will be calculated based on the purchase information from records available
                from Defendants and the previous settlement claims process. Your total known Settlement qualifying purchases
                from Defendants for the period between January 1, 2015, through February 29, 2020, is ${{au.purchaseNetTotal}}.
              </div>
            </div>
            <div class="row mt-4" style="margin-left: 0px; margin-right: 0px">
              <div class="col-md-12 text-center" style="background-color: lightgrey; font-size: 1.4em; font-weight: bold">
                Purchase Information
              </div>
            </div>
            <div class="row mt-1">
              <div class="col-md-6 float-left">
                <b>UniqueId:</b>  {{au.uniqueId}}
              </div>

              <div class="col-md-12 mt-3">
                <table class="table table-bordered table-striped" #listofInformation>
                  <thead>
                    <tr>
                      <th>DEFENDANT</th>
                      <th>
                        2015
                      </th>
                      <th>
                        2016
                      </th>
                      <th>
                        2017
                      </th>
                      <th>
                        2018
                      </th>
                      <th>
                        2019
                      </th>
                      <th>
                        2020
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style="font-weight:bold">Cargill</td>

                      <td>${{au.cargill2015}}</td>
                      <td>${{au.cargill2016}}</td>
                      <td>${{au.cargill2017}}</td>
                      <td>${{au.cargill2018}}</td>
                      <td>${{au.cargill2019}}</td>
                      <td>${{au.cargill2020}}</td>
                    </tr>
                    <tr>
                      <td style="font-weight:bold">JBS</td>

                      <td>${{au.jbs2015}}</td>
                      <td>${{au.jbs2016}}</td>
                      <td>${{au.jbs2017}}</td>
                      <td>${{au.jbs2018}}</td>
                      <td>${{au.jbs2019}}</td>
                      <td>${{au.jbs2020}}</td>
                    </tr>
                    <tr>
                      <td style="font-weight:bold">National Beef</td>
                      <td>${{au.nationalBeef2015}}</td>
                      <td>${{au.nationalBeef2016}}</td>
                      <td>${{au.nationalBeef2017}}</td>
                      <td>${{au.nationalBeef2018}}</td>
                      <td>${{au.nationalBeef2019}}</td>
                      <td>${{au.nationalBeef2020}}</td>
                    </tr>
                    <tr>
                      <td style="font-weight:bold">Tyson</td>
                      <td>${{au.tyson2015}}</td>
                      <td>${{au.tyson2016}}</td>
                      <td>${{au.tyson2017}}</td>
                      <td>${{au.tyson2018}}</td>
                      <td>${{au.tyson2019}}</td>
                      <td>${{au.tyson2020}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col-md-12" style="text-align:center; font-size:1.3em">
                <b><u>Purchase Total</u></b>&nbsp;&nbsp;&nbsp;${{au.purchaseNetTotal}}<br /><br />

              </div>
            </div>
            <div class="row mt-4" style="margin-left: 0px; margin-right: 0px">
              <div class="col-md-12 text-center" style="background-color: lightgrey; font-size: 1.4em; font-weight: bold">
                Sign Statement
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-12">
                By signing below I/we certify that (1) the above and foregoing information is true and correct; (2) I/we
                warrant that I am/we are duly authorized and have the legal capacity to sign this Claim Form on behalf of
                the direct purchaser entity; (3) I/we are not officers, directors, or employees of any Defendant; any entity
                in which any Defendant has a controlling interest; an affiliate, legal representative, heir, or assign of any
                Defendant; or a federal, state, or local governmental entity; and (4) I/we agree to submit additional
                information if requested, in order for the Claims Administrator to process my/our claim.
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-12">
                <div class="form-group">
                  <label class="titleBold" for="title">Title:</label>
                  <input type="text" class="form-control" id="title" formControlName="title" autocomplete="no"
                         trim="blur" [ngClass]="{ 'is-invalid': submitted && f.title.errors }" />
                  <div *ngIf="submitted && f.title.errors" class="invalid-feedback">
                    <div *ngIf="f.title.errors.required">This field is required</div>
                    <div *ngIf="f.title.errors.maxlength">This field must not be at greater 50 characters</div>
                    <div *ngIf="f.title.errors.minlength">This field must be at least 2 characters</div>
                    <div *ngIf="f.title.errors.pattern">
                      Only use letters, numbers, periods, spaces, hyphens,
                      brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-12">
                <div class="form-group">
                  <label class="titleBold" for="signature">Electronic Signature:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                  <input type="text" class="form-control" id="signature" formControlName="signature" autocomplete="no"
                         trim="blur" [ngClass]="{ 'is-invalid': submitted && f.signature.errors }" />
                  <div *ngIf="submitted && f.signature.errors" class="invalid-feedback">
                    <div *ngIf="f.signature.errors.required">This field is required</div>
                    <div *ngIf="f.signature.errors.maxlength">This field must not be at greater 50 characters</div>
                    <div *ngIf="f.signature.errors.minlength">This field must be at least 2 characters</div>
                    <div *ngIf="f.signature.errors.pattern">
                      Only use letters, numbers, periods, spaces, hyphens,
                      brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <re-captcha formControlName="googleRecaptchaToken" (resolved)="resolved($event)" [ngClass]="{ 'is-invalid':  f.googleRecaptchaToken.errors }"></re-captcha>
                  <div *ngIf="f.googleRecaptchaToken.errors" class="invalid-feedback">
                    <div *ngIf="f.googleRecaptchaToken.errors.required" style="color:red; font-size:80%">This field is required</div>
                  </div>
                  <!--<div style="color:#dc3545; font-size:80%; font-weight:bold">This field is required*</div>-->

                </div>
              </div>
            </div>
            <br />
            <div class="row" *ngIf="showSubmittalErrorWarning" style="background-color:lightpink">
              <div class="col-md-12 text-center" style="font-weight:bold">
                Claim Submission Failed, please fill out a paper claim form and email it to <a href="mailto:info@BeefDirectPurchaserSettlement.com">info@BeefDirectPurchaserSettlement.com</a>.<br />
                Thank You.
              </div>
            </div>
            <br />
            <ul class="list-inline text-center">
              <li><button type="submit" class="btn btn-primary" [disabled]="clicked">SUBMIT</button></li>
            </ul>
            <br />
          </form>
        </div>
      </div>
    </div>

























  </div>
